import React from 'react';
import SecondaryTitle from "../../Components/SecondaryTitle";
import Text from "../../Components/Text";

const BankingDetails = (props) => {
    const {
        data = {
            'bank_name':             '',
            'account_holder_name':   '',
            'sort_code':             '',
            'account_number':        '',
            'source_of_funds':       '',
        },
    } = props;

    return (
        <React.Fragment>
            <SecondaryTitle>Banking details</SecondaryTitle>
            <div className={'row m-0 p-0'}>
                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>Bank name:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.bank_name}</Text>
                </div>

                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>Account holder name:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.account_holder_name}</Text>
                </div>

                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>Sort code:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.sort_code}</Text>
                </div>

                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>Account number:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.account_number}</Text>
                </div>

                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>Source of funds:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.source_of_funds}</Text>
                </div>
            </div>
        </React.Fragment>
    );
}

export default BankingDetails;
